import { render, staticRenderFns } from "./LessonRequestList.vue?vue&type=template&id=8435ecfe&scoped=true&"
import script from "./LessonRequestList.vue?vue&type=script&lang=js&"
export * from "./LessonRequestList.vue?vue&type=script&lang=js&"
import style0 from "./LessonRequestList.vue?vue&type=style&index=0&id=8435ecfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8435ecfe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VContainer,VDataTable,VDialog,VPagination})
